export type DisplayUnit = 'rem' | 'vw' | 'px';
type Display = {
  value: number;
  unit: DisplayUnit;
};
type DisplayS = Display;
type DisplayM = Display;
type DisplayL = Display;
type DisplayXL = Display;
export type Displays = [DisplayXL, DisplayL, DisplayM, DisplayS];
export const DISPLAY_VIEWPORT: DisplayUnit = 'vw';
export const DISPLAY_REM: DisplayUnit = 'rem';
export const DISPLAY_MOBILE: DisplayS = {
  value: 0.8,
  unit: DISPLAY_VIEWPORT,
};
export const DISPLAY_PHABLET: DisplayM = {
  value: 0.7,
  unit: DISPLAY_VIEWPORT,
};
export const DISPLAY_TABLET: DisplayL = {
  value: 0.5,
  unit: DISPLAY_VIEWPORT,
};
export const DISPLAY_DESKTOP: DisplayXL = {
  value: 0.5,
  unit: DISPLAY_REM,
};
export const DISPLAYS: Displays = [
  DISPLAY_DESKTOP,
  DISPLAY_TABLET,
  DISPLAY_PHABLET,
  DISPLAY_MOBILE,
];
